import { dbPost } from '../../apis/commonApi';

class ResVideoListController {
  constructor(
    { store, updateStore },
    { searchParam, setSearchParam },
    { aplyList, setAplyList },
    { dataList, setDataList },
    modalService,
    validateService,
    navigate
  ) {
    this.store = store;
    this.updateStore = updateStore;
    this.searchParam = searchParam;
    this.setSearchParam = setSearchParam;
    this.aplyList = aplyList;
    this.setAplyList = setAplyList;
    this.dataList = dataList;
    this.setDataList = setDataList;
    this.modalService = modalService;
    this.validateService = validateService;
    this.navigate = navigate;
  }

  async fnSearchAply() {
    const url = '/aia/analysis/video/res/aply/list.do';

    let response;

    try {
      response = await dbPost(url, this.searchParam);

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {
        this.setAplyList(response);
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }

  async fnSearch(currentPage = 1) {
    const url = '/aia/analysis/video/res/list.do';

    let response;

    try {
      response = await dbPost(url, {
        ...this.searchParam,
        currentPage,
      });

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {
        this.setDataList(response);
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }

  async fnDetail(moveParam) {
    this.navigate('/ai/resVideoDetail', { state: moveParam });
  }

  async searchParamChange(model, value) {
    this.setSearchParam({ ...this.searchParam, [model]: value });
  }

  async disposy() {
    this.setSearchParam(null);
  }
}

export default ResVideoListController;
